import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcChatbot(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.563 14.025c.538 0 .974.436.974.975v.009a.975.975 0 1 1-1.95 0V15c0-.539.437-.975.976-.975M15.788 15a.975.975 0 1 0-1.95 0v.009a.975.975 0 1 0 1.95 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.188 5.75a3 3 0 1 1 3.75 2.905v.64c4.945.471 8.812 4.637 8.812 9.705v.167a2.583 2.583 0 0 1-2.583 2.583H4.833a2.583 2.583 0 0 1-2.583-2.583V19c0-5.196 4.064-9.443 9.188-9.734v-.61a3 3 0 0 1-2.25-2.906m3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 10.75A8.25 8.25 0 0 0 3.75 19v.167c0 .598.485 1.083 1.083 1.083h14.334c.598 0 1.083-.485 1.083-1.083V19A8.25 8.25 0 0 0 12 10.75",
    clipRule: "evenodd"
  }));
}
var IcChatbot = createNolIcon(/*#__PURE__*/forwardRef(SvgIcChatbot));

export { IcChatbot as I };
